export default function DarkThemeIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <g>
                <circle cx="12" cy="12" r="11"></circle>
                <circle cx="12" cy="14" r="1.5"></circle>
                <circle cx="7" cy="14" r="2"></circle>
                <circle cx="10" cy="8" r="3"></circle>
            </g>
        </svg>
    )  //these are temporary designs to be replaced by a sergo design
}